import { Container, Sprite, Text, TextStyle } from "pixi.js"
import { Terrain } from "./terrain/terrain"
import { Monsters } from "../monsters/monsters"
import { Projectiles } from "../projectiles"
import { Particles } from "../particles"

export async function World({ player }) {
  const world = new Container()

  const app = window.Game.app

  world.x = app.screen.width / 2
  world.y = app.screen.height / 2

  const intro = await Intro({ x: 400, y: 0 })
  world.addChild(intro)

  const tileGeneratedHandlers = []
  const tileRemovedHandlers = []

  const {
    terrain,
    init: terrainInit,
    tick: terrainTick,
    isSolid,
  } = await Terrain({
    player,
    onTileGenerated: (tile) =>
      tileGeneratedHandlers.forEach((handler) => handler(tile)),
    onTileRemoved: (tile) =>
      tileRemovedHandlers.forEach((handler) => handler(tile)),
  })

  const {
    particles,
    spawnParticle,
    tick: particlesTick,
  } = await Particles({ isSolid })

  world.addChild(particles)

  world.addChild(player)

  world.addChild(terrain)

  const {
    projectiles,
    spawnProjectile,
    tick: projectilesTick,
  } = await Projectiles({ isSolid })

  world.addChild(projectiles)

  const {
    monsters,
    tick: monstersTick,
    onTileGenerated: monstersOnTileGenerated,
    onTileRemoved: monstersOnTileRemoved,
  } = await Monsters({ player, isSolid, projectiles })

  tileGeneratedHandlers.push(monstersOnTileGenerated)
  tileRemovedHandlers.push(monstersOnTileRemoved)

  world.addChild(monsters)

  await terrainInit()

  const tick = (time) => {
    world.pivot.x = player.x
    world.pivot.y = player.y

    terrainTick(time)
    particlesTick(time)
    monstersTick(time)
    projectilesTick(time, { player, spawnParticle })
  }

  return { world, tick, isSolid, spawnProjectile }
}

function Intro({ x, y }) {
  const intro = new Container()

  intro.x = x
  intro.y = y

  const sprite = Sprite.from("res/controls.png")
  sprite.texture.source.scaleMode = "nearest"
  intro.addChild(sprite)

  sprite.y = 100
  sprite.scale = 3

  const title = new Text({
    x: 0,
    y: 0,
    text: "How deep can you dive?",
    style: new TextStyle({
      fontFamily: "cursive",
      fontSize: 32,
      fill: { color: "#fff" },
    }),
  })

  intro.addChild(title)

  const controlsText = new Container()
  controlsText.y = 100

  const style = new TextStyle({
    fontFamily: "monospace",
    fontSize: 24,
    fill: { color: "#fff" },
  })

  const move = new Text({
    x: 110,
    y: 29,
    text: "MOVE",
    style,
  })
  controlsText.addChild(move)

  const boost = new Text({
    x: 110,
    y: 68,
    text: "BOOST",
    style,
  })
  controlsText.addChild(boost)

  const shoot = new Text({
    x: 110,
    y: 108,
    text: "SHOOT",
    style,
  })
  controlsText.addChild(shoot)

  intro.addChild(controlsText)

  return intro
}
